var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_228_25424)" } }, [
        _c("path", {
          attrs: {
            d: "M12.3333 0C15.5159 0 18.5681 1.26428 20.8185 3.51472C23.069 5.76516 24.3333 8.8174 24.3333 12C24.3333 15.1826 23.069 18.2348 20.8185 20.4853C18.5681 22.7357 15.5159 24 12.3333 24C9.15065 24 6.09841 22.7357 3.84797 20.4853C1.59753 18.2348 0.333252 15.1826 0.333252 12C0.333252 8.8174 1.59753 5.76516 3.84797 3.51472C6.09841 1.26428 9.15065 0 12.3333 0ZM11.2083 5.625V12C11.2083 12.375 11.3958 12.7266 11.7098 12.9375L16.2098 15.9375C16.7254 16.2844 17.4239 16.1437 17.7708 15.6234C18.1176 15.1031 17.977 14.4094 17.4567 14.0625L13.4583 11.4V5.625C13.4583 5.00156 12.9567 4.5 12.3333 4.5C11.7098 4.5 11.2083 5.00156 11.2083 5.625Z",
            fill: "white",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_228_25424" } }, [
          _c("rect", {
            attrs: {
              width: "24",
              height: "24",
              fill: "white",
              transform: "translate(0.333252)",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }